import { t } from "i18next";
import { RequestTypeOf } from "../generated/routes";
import { VALIDATION_RULES } from "../utils/formValidation";
import { apiFetchRoute } from "./apiFetchRoute";

export const verifyEmail = async (
  email: string
): Promise<{ isValid: boolean; message?: string }> => {
  // Vérification du format de l'email avec le regex existant
  const emailRule = VALIDATION_RULES.email();
  if (!emailRule.test(email)) {
    return { isValid: false, message: emailRule.message };
  }

  try {
    type VerifyEmailRequest = RequestTypeOf<"postVerifyemail">;

    const body: VerifyEmailRequest = { email: email };
    const response = await apiFetchRoute("postVerifyemail", body);

    if (response.status === 409) {
      return { isValid: false, message: t("register-error-email-exists") };
    }

    if (!response.ok) {
      throw new Error("Erreur lors de la vérification de l'email");
    }

    return { isValid: true };
  } catch (error) {
    console.error("Erreur lors de la vérification de l'email:", error);
    return { isValid: false, message: t("register-error-email-check") };
  }
};
